import type { KitStatus } from '@cheqroom/api';
import { Archive, Dot } from '@cheqroom/icons';

export const getKitStatusIcon = (status: KitStatus) => (status === 'expired' ? Archive : Dot);
